export default "__VITE_PUBLIC_ASSET__5c6c37d3__"